
import DrawBase from "./DrawBase"
import EditCircle from "./EditCircle"
class DrawCircle extends DrawBase {
    constructor(options) {
        super(options);
    }

    //左键
    leftClick(evt) {
        var $this = this;
        var position = this.getCatesian3FromPX(evt.position);
        if ($this.positions.length == 0) {
            $this.positions.push(position.clone());
        }
        $this.positions.push(position);
    }

    mouseMove(evt) {
        var $this = this;
        if ($this.positions.length < 1) return;
        var cartesian = $this.getCatesian3FromPX(evt.endPosition);
        if (!$this.Cesium.defined($this.plot)) {
            $this.plot = $this.createCicle($this.positions);
            $this.entities.push($this.plot);
            $this.initEditor();
        }
        if ($this.plot) {
            $this.positions.pop();
            $this.positions.push(cartesian);
        }
    }

    initEditor() {
        var $this = this;
        $this.editHelp = new EditCircle(this.options); //初始化编辑类
    }
}

export default DrawCircle;